import { useEffect, useState } from "react";
import LandingPageClient from "@/components/LandingPageClient";
import { rpc } from "@/client/rpc";
import type { PerfumeProduct } from "@/services/catalogRepository";

export default function HomePage() {
  const [products, setProducts] = useState<PerfumeProduct[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    let active = true;
    rpc<PerfumeProduct[]>("getLandingPageProducts")
      .then((nextProducts) => {
        if (active) setProducts(nextProducts);
      })
      .catch((error) => console.warn("Landing-page products unavailable.", error))
      .finally(() => {
        if (active) setIsLoading(false);
      });
    return () => { active = false; };
  }, []);

  return <LandingPageClient isLoading={isLoading} products={products} />;
}
